<template>
  <div>
    <Card>
      <ui-select
        :items="items"
        label="Select"
        item-text="name"
        item-value="id"
        :return-object="false"
        :hide-details="2"
      ></ui-select>
    </Card>
    <Card>
      <ui-select
        :items="items"
        label="Select"
        item-text="name"
        item-value="id"
        :chips="true"
      ></ui-select>
    </Card>
    <Card>
      <ui-select
        :items="items"
        label="Select"
        item-text="name"
        item-value="id"
        :chips="true"
        :multiple="true"
      ></ui-select>
    </Card>
    <Card>
      <ui-select
        :withCustomArea="true"
        :items="items"
        label="Select"
        item-text="name"
        item-value="id"
      ></ui-select>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

const items = [
  {
    name: 'Option 1',
    id: '1',
  },
  {
    name: 'Option 2',
    id: '2',
  },
  {
    name: 'Option 3',
    id: '3',
  },
];
</script>
